/**
 * Indice visible de « probabilité de passage » parmi les suggestions actives.
 * Ce n’est pas une garantie : part relative des votes, des boosts et de l’activité globale,
 * avec un léger levier d’« activité de la foule » (somme boosts / votes).
 */

function scoreForTrack(votes, bidAmountCents, crowdEuros, crowdVotes, reactionTotal) {
  const v = Math.max(0, Number(votes) || 0);
  const bEur = Math.max(0, Number(bidAmountCents) || 0) / 100;
  const pulse =
    Math.log1p(Math.max(0, crowdEuros)) * 0.95 + Math.log1p(Math.max(0, crowdVotes)) * 0.65;
  const votePart = Math.pow(v + 1, 0.82) * 12;
  const boostPart = Math.log1p(bEur * 6 + 0.08) * 38;
  const crowdPart = pulse * 8;
  const react = Math.log1p(Math.max(0, Number(reactionTotal) || 0)) * 5.5;
  return Math.max(0.015, votePart + boostPart + crowdPart + react);
}

/**
 * @param {Array<{ id: string, votes?: number, bid_amount?: number }>} requests
 * @param {{ reactionTotals?: Record<string, number> }} [opts]
 */
export function computePassageChancePercent(requests, opts = {}) {
  if (!requests?.length) return {};

  const reactionTotals = opts.reactionTotals ?? {};

  const totalBoostCent = requests.reduce((acc, r) => acc + (Number(r.bid_amount) || 0), 0);
  const totalVotes = requests.reduce((acc, r) => acc + (Number(r.votes) || 0), 0);
  const crowdEuros = totalBoostCent / 100;

  const weights = requests.map((r) =>
    scoreForTrack(
      r.votes ?? 0,
      r.bid_amount ?? 0,
      crowdEuros,
      totalVotes,
      reactionTotals[r.id] ?? 0
    )
  );

  // Plancher léger puis rescaler pour rester lisible lorsque tout est plat
  const floor = weights.length <= 4 ? 0.035 : 0.02 / weights.length;
  const adjusted = weights.map((w) => w + floor);
  let probs = adjusted.map((w) => w / adjusted.reduce((a, b) => a + b, 0));

  const rawInts = probs.map((p) => Math.floor(p * 100 + 0.5));
  let drift = 100 - rawInts.reduce((a, b) => a + b, 0);
  const orderIdx = [...rawInts.entries()].sort((a, b) => b[1] - a[1]).map(([i]) => i);
  let k = 0;
  while (drift !== 0 && orderIdx.length) {
    const i = orderIdx[k % orderIdx.length];
    if (drift > 0) {
      rawInts[i] += 1;
      drift -= 1;
    } else if (rawInts[i] > 3) {
      rawInts[i] -= 1;
      drift += 1;
    }
    k += 1;
    if (k > 500) break;
  }

  const map = {};
  requests.forEach((r, i) => {
    map[r.id] = Math.max(3, Math.min(96, rawInts[i] ?? 0));
  });
  return map;
}
